// src/components/LoginModal.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const LoginModal = ({ isOpen, onClose, onRegisterOpen, onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    const loginData = { email, password };

    try {
      const response = await fetch('https://api2.apploja.com/smssender/login_usuario.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData),
      });
      const result = await response.json();

      if (result.status === 'success') {
        const { token, username } = result;

        localStorage.setItem('token', token);
        localStorage.setItem('username', username);
        localStorage.setItem('email', email);

        onLogin(token, username, email);
        onClose();  // Fechar o modal de login
        navigate('/contacts');
      } else {
        setError('Erro no login. Verifique as credenciais e tente novamente.');
      }
    } catch (error) {
      setError('Erro ao conectar com o servidor.');
    }
};


const handleGoogleSuccess = async (credentialResponse) => {
  const token = credentialResponse.credential;

  try {
    const decoded = jwtDecode(token);
    const { name, email, sub: googleId } = decoded;

    const loginResponse = await fetch('https://api2.apploja.com/smssender/login_usuario.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, googleId }),
    });
    const loginResult = await loginResponse.json();

    if (loginResult.status === 'success') {
      const { token, username } = loginResult;
      localStorage.setItem('token', token);
      localStorage.setItem('username', username);
      localStorage.setItem('email', email);

      onLogin(token, username, email);
      onClose();  // Fechar o modal de login
      navigate('/contacts');
    } else {
      onRegisterOpen({ name, email, googleId });
    }
  } catch (error) {
    setError('Erro ao tentar login com o Google');
  }
};

  const handleGoogleError = () => {
    setError('Falha no login com o Google');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-4">Login</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full mb-2 p-2 border rounded"
        />
        <input
          type="password"
          placeholder="Senha"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full mb-4 p-2 border rounded"
        />
        <button onClick={handleLogin} className="w-full bg-green-500 text-white p-2 rounded">Entrar</button>
        
        <div className="w-full mt-2">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
          />
        </div>
        
        <button onClick={() => onRegisterOpen()} className="w-full mt-2 bg-blue-500 text-white p-2 rounded">Cadastre-se</button>
        <button onClick={onClose} className="w-full mt-2 bg-gray-500 text-white p-2 rounded">Fechar</button>
      </div>
    </div>
  );
};

export default LoginModal;
